import type { ReceivedRecognitions } from '@/types/recognition';

import { api } from '@/api/api';

/**
 * The Recognition section of the employee portal. Without an employee the route reads the
 * recognitions of whoever is signed in; with one, that employee's, and only for a caller whose
 * performance scope reaches them -- the server answers 404 for anyone else.
 */
export default {
    async getReceivedRecognitions(employeeId?: string): Promise<ReceivedRecognitions> {
        const response = await api.get('/employee-portal/recognitions', {
            params: { employeeId },
        });
        return response.data;
    },
};
